export const MANUAL_LOCATION_PREFIX = "manual:";

export const extractManualSovPricing = (sovPricing) =>
  Object.fromEntries(
    Object.entries(sovPricing ?? {}).filter(([locationId]) =>
      locationId.startsWith(MANUAL_LOCATION_PREFIX)
    )
  );
